import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
}
export function Card({
  children,
  className = ''
}: CardProps) {
  return <section className={`rounded-xl border border-slate-200 bg-white shadow-sm ${className}`} data-id="element-13" data-mp="1zzj18kjjhcyw">
      {children}
    </section>;
}
interface CardHeaderProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}
export function CardHeader({
  title,
  description,
  icon,
  action
}: CardHeaderProps) {
  return <header className="flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4" data-id="element-14" data-mp="2iv95keey2lfy">
      <div className="flex items-start gap-3" data-id="element-15" data-mp="2xk5bo5xfxodx">
        {icon ? <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-brand-50 text-brand-700" data-id="element-16" data-mp="2smc5ve01uwe6">
            {icon}
          </span> : null}
        <div data-id="element-17" data-mp="36jilizph8ez6">
          <h2 className="text-base font-semibold text-slate-900" data-id="element-18" data-mp="31ms8ymcvs1ii">{title}</h2>
          {description ? <p className="mt-0.5 text-sm text-slate-500" data-id="element-19" data-mp="194xtyxjyji0w">{description}</p> : null}
        </div>
      </div>
      {action}
    </header>;
}